/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_Health_OkInputs */

const cs_kn_health_ok = /** @type {(inputs: Kn_Health_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Služba dostupná`)
};

const en_kn_health_ok = /** @type {(inputs: Kn_Health_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service available`)
};

/**
* | output |
* | --- |
* | "Service available" |
*
* @param {Kn_Health_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_health_ok = /** @type {((inputs?: Kn_Health_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_Health_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_health_ok(inputs)
	return cs_kn_health_ok(inputs)
});